import { getChildrensIsActive } from '~/utils/helpers';
import type { SidebarLink } from '~/interfaces/sidebar.interface';

const useGeneralLinks = () => {
  const { t } = useI18n();
  const route = useRoute();
  const uniqueKey = getUniqueKey();

  const isCountries = computed(() => route.path.includes('/countries'));
  const isUnits = computed(() => route.path.includes('/units'));
  const childrens = computed(() => {
    return [
      {
        level: 2,
        isVisible: true,
        href: '/countries',
        icon: ``,
        label: t('routes.countries'),
        isActive: isCountries.value,
      },
      {
        level: 2,
        isVisible: true,
        href: '/units',
        icon: ``,
        label: t('routes.units'),
        isActive: isUnits.value,
      },
    ];
  });

  const links = computed(() => {
    const data = [{ childrens: childrens.value }];
    const isActive = getChildrensIsActive(data as SidebarLink[]);
    return [
      {
        uniqueKey,
        level: 1,
        isVisible: true,
        href: '/general',
        icon: ``,
        label: t('routes.general'),
        isActive,
        childrens: childrens.value,
      },
    ];
  });

  return { links };
};
export default useGeneralLinks;
